import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { ProgressBarService } from '../../core/progress-bar.service';
import { StoreService } from '../../core/store.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { MedicalHistory } from './shared/medical-history.model';
import { SurgicalHistory } from './shared/surgical-history.model';
import { Medication } from "./shared/medication.model";

@Component({
  selector: 'medical-and-surgical-history',
  templateUrl: './medical-and-surgical-history.component.html',
})
export class MedicalAndSurgicalHistoryComponent {


  title = 'medicalAndSirgicalHistory.title';
  isStaff = this.store.state.isStaff;
  progressBar = this.progress.medicalAndSurgicalHistory;
  showDiabetes = false;
  medicalHistory: MedicalHistory = this.store.state.consent.medicalHistory;
  surgicalHistory: SurgicalHistory = this.store.state.consent.surgicalHistory;

  // medications
  name: string = '';
  dose: string = '';
  often: string = '';
  why: string = '';
  medications: Medication[] = this.store.state.consent.medications;


  constructor(private router: Router,
    private progress: ProgressBarService,
    private store: StoreService,
    private navigation: NavigationService) { }

  clear() {
    this.name = '';
    this.dose = '';
    this.often = '';
    this.why = '';
  }

  add() {
    let medication: Medication = {
      name: this.name,
      dose: this.dose,
      often: this.often,
      why: this.why
    };

    this.store.state.consent.medications.push(medication);
    this.clear();
  }

  back() {
    this.router.navigate([this.navigation.medicalAnsSurgicalHistory.back]);
  }

  next() {
    this.store.state.consent.medicalHistory = this.medicalHistory;
    this.store.state.consent.surgicalHistory = this.surgicalHistory;
    this.router.navigate([this.navigation.medicalAnsSurgicalHistory.next]);
  }
}
